import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Domu from '@/pages/Domu'

//Osoby
import Klienti from '@/pages/KlientiSpolupracovnici/Klienti'
import Spolupracovnici from '@/pages/KlientiSpolupracovnici/Spolupracovnici'
import KlientDetail from '@/pages/KlientiSpolupracovnici/KlientDetail'
import ObjednavkyJednorazovychProduktu from '@/pages/KlientiSpolupracovnici/ObjednavkyJednorazovychProduktu'
import ObjednavkyJednorazovychProduktuDetail from '@/pages/KlientiSpolupracovnici/ObjednavkyJednorazovychProduktuDetail'

//Osoby detail
import ObchodyProvizeDetail from '@/pages/Klienti/ObchodyProvizeDetail'
import ElektronickaPenezenkaDetail from '@/pages/Klienti/ElektronickaPenezenkaDetail'

//Produkty
import PredaniProduktu from '@/pages/Produkty/PredaniProduktu'
import ProduktDetail from '@/pages/Produkty/ProduktDetail'
import Produkty from '@/pages/Produkty/Produkty'
import SporiciProduktDetail from '@/pages/Produkty/SporiciProduktDetail'
import SporiciProdukty from '@/pages/Produkty/SporiciProdukty'

//Objednavky
import Objednavky from '@/pages/Objednavky/Objednavky'
import ObjednavkyDetail from '@/pages/Objednavky/ObjednavkyDetail'

//Fixace
import Fixace from '@/pages/Fixace/Fixace'
import FixaceDetail from '@/pages/Fixace/FixaceDetail'
import FixacePruvodce from '@/pages/Fixace/FixacePruvodce'

//Testtools
import TestToolsNovaPlatba from '@/pages/TestTools/NovaPlatba'
import Log from '@/pages/TestTools/Log'
import LogEshopPrihlaseni from '@/pages/TestTools/LogEshopPrihlaseni'
import LogPrihlaseni from '@/pages/TestTools/LogPrihlaseni'
import CenyProduktu from '@/pages/TestTools/CenyProduktu'
import NastaveniKariery from '@/pages/TestTools/NastaveniKariery'
import NastaveniParovani from '@/pages/TestTools/NastaveniParovani'
import NastaveniPocatecnichKreditu from '@/pages/TestTools/NastaveniPocatecnichKreditu'

//Platby
import BankovniVypis from '@/pages/Platby/BankovniVypis'
import PlatbyVraceni from '@/pages/Platby/PlatbyVraceni'
import NezaplaceneObjednavky from '@/pages/Platby/NezaplaceneObjednavky'

//Admin
import ObchodyProvize from '@/pages/Admin/ObchodyProvize'
import ObchodyProvizeAdminDetail from '@/pages/Admin/ObchodyProvizeAdminDetail'

//Prehledy
import ProduktyPredani from '@/pages/Prehledy/ProduktyPredani'
import SjednanaSporeni from '@/pages/Prehledy/SjednanaSporeni'
import RozesporeneProdukty from '@/pages/Prehledy/RozesporeneProdukty'
import PrehledElektronickychPenezenek from '@/pages/Prehledy/PrehledElektronickychPenezenek'
import PrehledPrepoctuProvizi from '@/pages/Prehledy/PrehledPrepoctuProvizi'
import PrehledFaktury from '@/pages/Prehledy/PrehledFaktury'
import PrehledSpolupracovniku from '@/pages/Prehledy/PrehledSpolupracovniku'
import KarieraKontrola from '@/pages/Prehledy/KarieraKontrola'

//Karierni plan
import KarierniPlan from '@/pages/KlientiSpolupracovnici/KarierniPlan'

//Karierni plan
import MigraceTroyskaUnce from '@/pages/TestTools/MigraceTroyskaUnce'

//Dodavatele
import DodavateleNovaObjednavka from '@/pages/Dodavatele/DodavateleNovaObjednavka'
import DodavateleNovaObjednavkaVyroby from '@/pages/Dodavatele/DodavateleNovaObjednavkaVyroby'
import ObjednavkyDodavatelum from '@/pages/Dodavatele/ObjednavkyDodavatelum'
import DodavateleObjednavkaDetail from '@/pages/Dodavatele/DodavateleObjednavkaDetail'
import DodavateleObjednavkaFaktura from '@/pages/Dodavatele/DodavateleObjednavkaFaktura'
import SeznamDodavatelu from '@/pages/Dodavatele/SeznamDodavatelu'

//Sklady
import PrijemkaObjednavkyDodavatele from '@/pages/Sklady/PrijemkaObjednavkyDodavatele'
import SkladHotovychProduktu from '@/pages/Sklady/SkladHotovychProduktu'
import SkladMetalKonto from '@/pages/Sklady/SkladMetalKonto'
import PohybyVeSkladu from '@/pages/Sklady/PohybyVeSkladu'
import PohybyVeSkladuHotovychVyrobku from '@/pages/Sklady/PohybyVeSkladuHotovychVyrobku'
import PohybyMaterialu from '@/pages/Sklady/PohybyMaterialu'

//Fakturace provizi
import FakturaceProvizi from '@/pages/Fakturace/FakturaceProvizi'
import FakturaceObchodyProvize from '@/pages/Fakturace/FakturaceObchodyProvize'

//Slevy
import JednorazoveNakupy from '@/pages/Slevy/SlevyJednorazoveNakupy'
import PoplatkySporeni from '@/pages/Slevy/SlevyPoplatkySporeni'

//Vykup, prodej
import VykupKovu from '@/pages/VykupProdej/VykupKovu'
import DrobnyProdej from '@/pages/VykupProdej/DrobnyProdej'

//Zpravy
import Zpravy from '@/pages/Zpravy/Zpravy'

//Faktury
import Faktury from '@/pages/Faktury/Faktury'

//Udalosti
import Udalosti from '@/pages/Udalosti/Udalosti'
import SkupinyUcastniku from '@/pages/Udalosti/SkupinyUcastniku'
import TypyUdalosti from '@/pages/Udalosti/TypyUdalosti'

//Penezenka
import PrehledPenezenek from '@/pages/Penezenka/PrehledPenezenek'

//Nastaveni
import Nastaveni from '@/pages/Nastaveni/Nastaveni'

//Statistiky
import Statistiky from '@/pages/Statistiky/Statistiky'
import SkupinoveStatistiky from '@/pages/Statistiky/SkupinoveStatistiky'

//Blog
import BlogKategorie from '@/pages/Blog/BlogKategorie'
import BlogPrispevky from '@/pages/Blog/BlogPrispevky'
import BlogPrispevkyDetail from '@/pages/Blog/BlogPrispevkyDetail'

//Videoblog
import VideoBlogKategorie from '@/pages/VideoBlog/VideoBlogKategorie'
import VideoBlogPrispevky from '@/pages/VideoBlog/VideoBlogPrispevky'
import VideoBlogPrispevkyDetail from '@/pages/VideoBlog/VideoBlogPrispevkyDetail'


export default new Router({
  routes: [
    {
      path: '/',
      name: 'Domu',
      component: Domu
    },
    {
      path: '/klienti',
      name: 'Klienti',
      component: Klienti
    },
    {
      path: '/spolupracovnici',
      name: 'Spolupracovnici',
      component: Spolupracovnici
    },
    {
      path: '/klienti/:id',
      name: 'KlientDetail',
      component: KlientDetail,
      props: (route) => ({ id: route.params.id, tab: "informace" })
    },
    {
      path: '/klienti/:id/sporici-programy/:sporici_program/',
      name: 'KlientDetailTab',
      component: KlientDetail,
      props: (route) => ({ id: route.params.id, tab: "sporici-programy", sporici_program: route.params.sporici_program })
    },
    {
      path: '/klienti/:id/sporici-programy/',
      name: 'KlientDetailTab4',
      component: KlientDetail,
      props: (route) => ({ id: route.params.id, tab: "sporici-programy" }),
    },
    {
      path: '/klienti/:id/:tab',
      name: 'KlientDetailTab2',
      component: KlientDetail,
      props: (route) => ({ id: route.params.id, tab: route.params.tab })
    },
    {
      path: '/spolupracovnici/:id',
      name: 'KlientDetail2',
      component: KlientDetail,
      props: (route) => ({ id: route.params.id, tab: "informace" })
    },
    {
      path: '/spolupracovnici/:id/:tab',
      name: 'KlientDetailTab3',
      component: KlientDetail,
      props: (route) => ({ id: route.params.id, tab: route.params.tab })
    },
    {
      path: '/dodavatele/seznam',
      name: 'SeznamDodavatelu',
      component: SeznamDodavatelu
    },
    {
      path: '/dodavatele/objednavky',
      name: 'ObjednavkyDodavatelum',
      component: ObjednavkyDodavatelum
    },
    {
      path: '/admin/obchody-a-provize',
      name: 'ObchodyProvize',
      component: ObchodyProvize
    },
    {
      path: '/admin/obchody-a-provize/:id',
      name: 'ObchodyProvizeAdminDetail',
      component: ObchodyProvizeAdminDetail,
      props: (route) => ({ id: route.params.id })
    },
    {
      path: '/sklad/sklad-hotovych-produktu',
      name: 'SkladHotovychProduktu',
      component: SkladHotovychProduktu
    },
    {
      path: '/sklad/pohyby-ve-skladu/:id',
      name: 'PohybyVeSkladu',
      component: PohybyVeSkladu,
      props: (route) => ({ id: route.params.id })
    },
    {
      path: '/sklad/pohyby-ve-skladu-hotovych-vyrobku',
      name: 'PohybyVeSkladuHotovychVyrobku',
      component: PohybyVeSkladuHotovychVyrobku
    },
    {
      path: '/sklad-metal-konto/:id',
      name: 'PohybyMaterialu',
      component: PohybyMaterialu,
      props: (route) => ({ id: route.params.id })
    },
    {
      path: '/sklad/sklad-metal-konto',
      name: 'SkladMetalKonto',
      component: SkladMetalKonto
    },
    {
      path: '/platby/nezaplacene-objednavky',
      name: 'NezaplaceneObjednavky',
      component: NezaplaceneObjednavky
    },
    {
      path: '/obchody-a-provize-detail',
      name: 'ObchodyProvizeDetail',
      component: ObchodyProvizeDetail
    },
    {
      path: '/produkty',
      name: 'Produkty',
      component: Produkty
    },
    {
      path: '/produkty/:id',
      name: 'produkt',
      component: ProduktDetail,
      props: (route) => ({ id: route.params.id })
    },
    {
      path: '/produkty/:id/upravit',
      name: 'produkt2',
      component: ProduktDetail,
      props: (route) => ({ id: route.params.id, editProduct: true })
    },
    {
      path: '/sporici-produkty',
      name: 'SporiciProdukty',
      component: SporiciProdukty
    },
    {
      path: '/sporici-produkty/:id',
      name: 'sporici-produkt',
      component: SporiciProduktDetail,
      props: (route) => ({ id: route.params.id })
    },
    {
      path: '/sporici-produkty/:id/upravit',
      name: 'sporici-produkt2',
      component: SporiciProduktDetail,
      props: (route) => ({ id: route.params.id, editProduct: true })
    },
    {
      path: '/predani-produktu',
      name: 'PredaniProduktu',
      component: PredaniProduktu
    },
    {
      path: '/elektronicka-penezenka-detail',
      name: 'ElektronickaPenezenkaDetail',
      component: ElektronickaPenezenkaDetail
    },
    {
      path: '/objednavky-sporici',
      name: 'Objednavky',
      component: Objednavky
    },
    {
      path: '/objednavky-sporici/:id',
      name: 'ObjednavkyDetail',
      component: ObjednavkyDetail,
      props: (route) => ({ id: route.params.id })
    },
    {
      path: '/objednavky-jednorazove',
      name: 'ObjednavkyJednorazovychProduktu',
      component: ObjednavkyJednorazovychProduktu
    },
    {
      path: '/objednavky-jednorazove/:id',
      name: 'ObjednavkyJednorazovychProduktuDetail',
      component: ObjednavkyJednorazovychProduktuDetail,
      props: (route) => ({ id: route.params.id })
    },
    {
      path: '/nastaveni',
      name: 'Nastaveni',
      component: Nastaveni
    },
    {
      path: '/nastaveni/uzivatele',
      name: 'Nastaveni2',
      component: Nastaveni
    },
    {
      path: '/nastaveni/ciselniky',
      name: 'Nastaveni3',
      component: Nastaveni
    },
    {
      path: '/test-tools/nova-platba',
      name: 'TestToolsNovaPlatba',
      component: TestToolsNovaPlatba
    },
    {
      path: '/test-tools/log',
      name: 'Log',
      component: Log
    },
    {
      path: '/test-tools/log-eshop-prihlaseni',
      name: 'LogEshopPrihlaseni',
      component: LogEshopPrihlaseni
    },
    {
      path: '/test-tools/log-prihlaseni',
      name: 'LogPrihlaseni',
      component: LogPrihlaseni
    },
    {
      path: '/test-tools/ceny-produktu',
      name: 'CenyProduktu',
      component: CenyProduktu
    },
    {
      path: '/test-tools/kariera',
      name: 'NastaveniKariery',
      component: NastaveniKariery
    },
    {
      path: '/test-tools/migrace-troyska-unce',
      name: 'MigraceTroyskaUnce',
      component: MigraceTroyskaUnce
    },
    {
      path: '/test-tools/parovani',
      name: 'NastaveniParovani',
      component: NastaveniParovani
    },
    {
      path: '/test-tools/pocateni-kredity',
      name: 'NastaveniPocatecnichKreditu',
      component: NastaveniPocatecnichKreditu
    },
    {
      path: '/platby/bankovni-vypis',
      name: 'BankovniVypis',
      component: BankovniVypis
    },
    {
      path: '/platby/vraceni-plateb',
      name: 'PlatbyVraceni',
      component: PlatbyVraceni
    },
    {
      path: '/fixace',
      name: 'Fixace',
      component: Fixace
    },
    {
      path: '/fixace/pruvodce',
      name: 'FixacePruvodce',
      component: FixacePruvodce
    },
    {
      path: '/fixace/:id',
      name: 'FixaceDetail',
      component: FixaceDetail,
      props: (route) => ({ id: route.params.id })
    },
    {
      path: '/prehledy/predani',
      name: 'ProduktyPredani',
      component: ProduktyPredani
    },
    {
      path: '/prehledy/sjednana-sporeni',
      name: 'SjednanaSporeni',
      component: SjednanaSporeni
    },
    {
      path: '/prehledy/rozesporene-produkty',
      name: 'RozesporeneProdukty',
      component: RozesporeneProdukty
    },
    {
      path: '/prehledy/elektronicke-penezenky',
      name: 'PrehledElektronickychPenezenek',
      component: PrehledElektronickychPenezenek
    },
    {
      path: '/prehledy/prepocty-provizi',
      name: 'PrehledPrepoctuProvizi',
      component: PrehledPrepoctuProvizi
    },
    {
      path: '/prehledy/faktury',
      name: 'PrehledFaktury',
      component: PrehledFaktury
    },
    {
      path: '/prehledy/spolupracovnici',
      name: 'PrehledSpolupracovniku',
      component: PrehledSpolupracovniku
    },
    {
      path: '/prehledy/karierni-plan',
      name: 'KarierniPlan',
      component: KarierniPlan
    },
    {
      path: '/dodavatele/nova-objednavka',
      name: 'DodavateleNovaObjednavka',
      component: DodavateleNovaObjednavka
    },
    {
      path: '/dodavatele/nova-objednavka-vyroby',
      name: 'DodavateleNovaObjednavkaVyroby',
      component: DodavateleNovaObjednavkaVyroby
    },
    {
      path: '/dodavatele/objednavky/:id',
      name: 'DodavateleObjednavkaDetail',
      component: DodavateleObjednavkaDetail,
      props: (route) => ({ id: route.params.id })
    },
    {
      path: '/dodavatele/objednavky/:id/faktura',
      name: 'DodavateleObjednavkaFaktura',
      component: DodavateleObjednavkaFaktura,
      props: (route) => ({ id: route.params.id })
    },
    {
      path: '/dodavatele/objednavky/:id/prijemky',
      name: 'PrijemkaObjednavkyDodavatele',
      component: PrijemkaObjednavkyDodavatele,
      props: (route) => ({ id: route.params.id })
    },
    {
      path: '/fakturace-provizi',
      name: 'FakturaceProvizi',
      component: FakturaceProvizi
    },
    {
      path: '/fakturace-provizi/:id',
      name: 'FakturaceObchodyProvize',
      component: FakturaceObchodyProvize,
      props: (route) => ({ id: route.params.id })
    },
    {
      path: '/slevy/jednorazove-nakupy',
      name: 'JednorazoveNakupy',
      component: JednorazoveNakupy
    },
    {
      path: '/slevy/poplatky-sporeni',
      name: 'PoplatkySporeni',
      component: PoplatkySporeni
    },
    {
      path: '/vykup/vykup-kovu',
      name: 'VykupKovu',
      component: VykupKovu
    },
    {
      path: '/vykup/drobny-prodej',
      name: 'DrobnyProdej',
      component: DrobnyProdej
    },
    {
      path: '/faktury',
      name: 'Faktury',
      component: Faktury
    },
    {
      path: '/zpravy',
      name: 'Zpravy',
      component: Zpravy
    },
    {
      path: '/udalosti/prehled-udalosti',
      name: 'Udalosti',
      component: Udalosti
    },
    {
      path: '/udalosti/typy-udalosti',
      name: 'TypyUdalosti',
      component: TypyUdalosti
    },
    {
      path: '/udalosti/skupiny-ucastniky',
      name: 'SkupinyUcastniku',
      component: SkupinyUcastniku
    },
    {
      path: '/prehled-penezenek',
      name: 'PrehledPenezenek',
      component: PrehledPenezenek
    },
    {
      path: '/statistiky/:id',
      name: 'Statistiky',
      component: Statistiky,
      props: (route) => ({ id: route.params.id })
    },
    {
      path: '/statistiky/:tab/:id',
      name: 'SkupinoveStatistiky',
      component: SkupinoveStatistiky,
      props: (route) => ({ tab: route.params.tab, id: route.params.id  })
    },
    {
      path: '/blog/kategorie',
      name: 'BlogKategorie',
      component: BlogKategorie,
    },
    {
      path: '/blog/prispevky',
      name: 'BlogPrispevky',
      component: BlogPrispevky,
    },
    {
      path: '/prispevky/:id',
      name: 'BlogPrispevkyDetail',
      component: BlogPrispevkyDetail,
      props: (route) => ({ id: route.params.id })
    },
    {
      path: '/videoblog/kategorie',
      name: 'VideoBlogKategorie',
      component: VideoBlogKategorie,
    },
    {
      path: '/videoblog/prispevky',
      name: 'VideoBlogPrispevky',
      component: VideoBlogPrispevky,
    },
    {
      path: '/video-prispevky/:id',
      name: 'VideoBlogPrispevkyDetail',
      component: VideoBlogPrispevkyDetail,
      props: (route) => ({ id: route.params.id })
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router.js